<template>
  <div v-if="theme === 'button'" class="language-toggle">
    <button
      :class="['left', isEng ? 'active' : '']"
      :disabled="isEng"
      @click="changeLang('en-GB')"
    >
      EN
    </button>
    <button
      :class="['right', !isEng ? 'active' : 'arabic-font']"
      :disabled="!isEng"
      @click="changeLang('ar-SA')"
    >
      عربى
    </button>
  </div>
  <a
    v-else
    :class="{ 'arabic-font': isEng }"
    @click.prevent="changeLang(isEng ? 'ar-SA' : 'en-GB')"
  >
    {{ isEng ? 'التبديل إلى اللغة العربية' : 'Switch to english' }}
  </a>
</template>

<script>
export default {
  props: {
    theme: {
      type: String,
      default: 'button'
    }
  },
  computed: {
    isEng() {
      return this.$skI18n.locale === 'en-GB';
    }
  },
  methods: {
    changeLang(lang = this.lang === 'en-GB' ? 'ar-SA' : 'en-GB') {
      this.$skI18n.changeLanguage(lang);

      this.$store.commit('setApp', {});
      this.$store.commit('setHomePage', {});
      this.$store.commit('setPages', []);
      this.$store.commit('setReports', []);
    }
  }
};
</script>

<style lang="scss" scope>
@import '../scss/base/variables.scss';
@import '../scss/helpers/mixins';
@import '../scss/base/fonts';

.language-toggle {
  height: 55px;
  display: flex;
  align-items: center;

  button {
    height: calc(40px * 2 / 3);
    background: $grey-3;
    color: $white;
    font-weight: 600;
    font-size: 0.8em;
    border: 0;

    &.left {
      border-radius: 4px 0 0 4px;
    }

    &.right {
      border-radius: 0 4px 4px 0;
    }

    &.active {
      color: $white;
      background: $primary;
    }

    @include breakpoint(L) {
      width: 50px;
      height: calc(50px * 2 / 3);
    }
    @include breakpoint(XL) {
      width: 60px;
      height: calc(60px * 2 / 3);
      font-size: 1em;
    }
  }

  // This is so that they don't swap around in rtl languages
  [dir='rtl'] & {
    .left {
      order: 1;
    }

    .right {
      order: 0;
    }
  }
}
</style>
